import FocusedViewFilter from 'owa-service/lib/contract/FocusedViewFilter';
import getFocusedFilterForTable from 'mini-mail-list-store/lib/utils/getFocusedFilterForTable';
import getSelectedTableView from 'mini-mail-list-store/lib/utils/getSelectedTableView';
import MailListFilterButton from 'mini-mail-list-filter/lib/components/MailListFilterButton';
import React from 'react';
import selectFocusedPivot from 'mini-mail-list-actions/lib/actions/selectFocusedPivot';
import strings from 'owa-strings/owa-mini-strings';
import { BinarySwitch } from 'mini-binary-switch';
import { getStore as getMailStore } from 'owa-mail-store/lib/store/Store';
import { Header, HeaderIcon } from 'mini-header';
import { isConsumer } from 'owa-shared-start/lib/sessionDiagnostics';
import { observer } from 'mobx-react-lite';
import { PerformanceDatapoint } from 'owa-analytics';
import { shouldShowMailListHeaderForFolderId } from '../utils/mailList/shouldShowMailListHeaderForFolderId';
import { TableView } from 'mini-mail-prefetch';
import {
    getNativeAdShowStatus,
    isGdprAdMarket,
    NativeAdUserFlight,
} from 'mini-mail-nativead-userchecker';

import {
    shouldShowEmptyFolderButtonForFolderId,
    EmptyFolderButton,
} from 'mini-mail-empty-folder-button';

const styles = require('./MailListViewSecondaryHeader.scss');
const classNames = require('classnames/bind').bind(styles);

const MailListViewSecondaryHeader = props => {
    const selectedTableView: TableView = getSelectedTableView();
    const { forwardedRefs } = props;

    const folderId: string =
        selectedTableView && selectedTableView.tableQuery
            ? selectedTableView.tableQuery.folderId
            : null;
    const selectedFocusedFilter = selectedTableView
        ? getFocusedFilterForTable(selectedTableView)
        : FocusedViewFilter.None;

    const onFocusedOtherClick = (isLeftSelectedNow: boolean) => {
        const datapoint = new PerformanceDatapoint('FocusedPivotClick', { isCore: true });

        const selectedFilter: FocusedViewFilter = isLeftSelectedNow
            ? FocusedViewFilter.Focused
            : FocusedViewFilter.Other;
        // logging usage
        datapoint.addCustomData([selectedFilter]);
        selectFocusedPivot(selectedFilter);
        datapoint.end();
    };

    const bannerView =
        isConsumer() &&
        isGdprAdMarket() &&
        getNativeAdShowStatus() == NativeAdUserFlight.PrebidMobileBannerAd;

    const isShowingEmptyFolderButton: boolean = shouldShowEmptyFolderButtonForFolderId(folderId);
    const isDisablingEmptyFolderButton = !getMailStore().folders?.folderTable?.get(folderId)
        ?.TotalCount;

    const leftIcon: HeaderIcon = isShowingEmptyFolderButton
        ? {
              icon: (
                  <EmptyFolderButton
                      folderId={folderId}
                      isDisabled={isDisablingEmptyFolderButton}
                  />
              ),
              iconStyle: classNames(styles.headerButton, {
                  [styles.pressed]: !isDisablingEmptyFolderButton,
              }),
          }
        : {
              icon: (
                  <BinarySwitch
                      leftLabel={strings.focusFolderLabel}
                      rightLabel={strings.otherFolderLabel}
                      isLeftSelected={selectedFocusedFilter === FocusedViewFilter.Focused}
                      onClick={onFocusedOtherClick}
                      getAriaLabel={(isFocusedSelected: boolean) =>
                          isFocusedSelected
                              ? strings.focusFolderSelectedAriaLabel
                              : strings.otherFolderSelectedAriaLabel
                      }
                      ref={forwardedRefs?.switchRef}
                  />
              ),
              iconStyle: classNames(
                  {
                      [styles.headerButtonBanner]: bannerView,
                      [styles.headerButton]: !bannerView,
                  },
                  styles.pressed
              ),
          };

    const rightIcon: HeaderIcon = {
        icon: (
            <MailListFilterButton
                selectedTableView={selectedTableView}
                filterRef={forwardedRefs?.filterRef}
            />
        ),
        iconStyle: classNames(
            {
                [styles.headerButtonBanner]: bannerView,
                [styles.headerButton]: !bannerView,
            },
            styles.pressed
        ),
    };

    return shouldShowMailListHeaderForFolderId(folderId) ? (
        <Header
            headerStyles={bannerView ? styles.headerBanner : styles.header}
            leftIcon={leftIcon}
            rightIcon={rightIcon}
            hideExtensionHeader
        />
    ) : null;
};

export default observer(MailListViewSecondaryHeader);
